import React from 'react';
import { Card, CardContent } from '../ui/card';

export function OverviewStats({ stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card className="border-l-4 border-l-blue-500">
        <CardContent className="p-4">
          <div className="text-2xl font-bold text-blue-600">{stats?.ykk_item_count || 0}</div>
          <div className="text-sm text-muted-foreground">YKK Bhoruka</div>
        </CardContent>
      </Card>
      <Card className="border-l-4 border-l-yellow-500">
        <CardContent className="p-4">
          <div className="text-2xl font-bold text-yellow-600">{stats?.unitized_item_count || 0}</div>
          <div className="text-sm text-muted-foreground">Unitized</div>
        </CardContent>
      </Card>
      <Card className="border-l-4 border-l-purple-500">
        <CardContent className="p-4">
          <div className="text-2xl font-bold text-purple-600">{stats?.other_item_count || 0}</div>
          <div className="text-sm text-muted-foreground">Other Aluminum</div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <div className="text-2xl font-bold">{stats?.remnants_available || 0}</div>
          <div className="text-sm text-muted-foreground">Remnants Available</div>
        </CardContent>
      </Card>
    </div>
  );
}
